export interface AuthState {
  id: number | null;
  name: string | null;
  accessToken: string | null;
  remember: boolean;
}

export default {
  namespaced: true,
  state: {
    id: null,
    name: null,
    accessToken: localStorage.getItem("user-token") || null,
    remember: false,
  } as AuthState,
  mutations: {
    login(state: AuthState, payload: AuthState) {
      state.id = payload.id;
      state.name = payload.name;
      state.accessToken = payload.accessToken;
    },
    logout(state: AuthState) {
      state.id = null;
      state.name = null;
      state.accessToken = null;
    },
  },
  actions: {},
  getters: {
    isAuthenticated(state: AuthState) {
      return state.accessToken !== null;
    },
  },
};
